import { usePricingContext } from '@vp/react-pricing-context';

/**
 * usePricingContextIfProvided handles the case where the BriefProvider is used without pricing
 * context. Since hooks can't be called conditionally, we have to wrap the call in a try/catch.
 *
 * BriefProvider is currently used in Matching and Collaboration where PricingContextProvider is
 * not available.
 */

export function usePricingContextIfProvided() {
    try {
        return usePricingContext();
    } catch {
        return undefined;
    }
}
